<h2>{{ title() }}</h2>
<p>{{ getSubtitle() }}</p>
